import * as React from 'react';
import { Typography } from '@mui/material'
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../utils/FormatUtils";
import InvoiceSimpleTable, { SimpleColumnDef } from "../../../component/InvoiceSimpleTable";

const PayableInvoiceTaxes = (props: { invoice: any, type?: string }) => {

    const { t } = useTranslation('finance', { keyPrefix: 'payable-invoices' });

    const columnDefs: SimpleColumnDef[] = [
        {
            field: 'vatRate',
            headerName: t("preview.tables.taxes.vat-rate"),
            width: '60%',
            valueFormatter: (data) => {
                return {
            
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'left'} fontWeight={600} sx={{ paddingTop: "2ch" }}>{data.vatRate}</Typography>
                        }
                        if (data.type === "TOTAL_WITHHOLDING_TAX" || data.type === "TOTAL_NET") {
                            if (!data?.vatRate.includes("0%")){
                                return <Typography align={'left'} fontWeight={600}>{data.vatRate}</Typography>
                            } else {
                                return "";
                            }
                        }
                        if (data.rate === 0) {
                            return <Typography align={'left'} fontWeight={400}>{t("preview.tables.taxes.zero-vat-label")}</Typography>
                        }
                        return <Typography align={'left'} fontWeight={400}>{data.rate}% {t("preview.tables.taxes.vat-label")}</Typography>
                    }
                }
            }
        },
        {
            field: 'totalNetPrice',
            headerName: t("preview.tables.taxes.net-amount"),
            width: "14%",
            cellStyle: 'right',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'right'} fontWeight={600} sx={{ paddingTop: "2ch" }}>{formatCurrency(data.totalNetPrice, props.invoice.currency, 0.01)}</Typography>
                        } else if (data.type === "TOTAL_WITHHOLDING_TAX" || data.type === "TOTAL_NET") {
                            return <Typography align={'right'} fontWeight={600}></Typography>
                        } else {
                            return <Typography align={'right'} fontWeight={400}>{formatCurrency(data.totalNetPrice, props.invoice.currency, 0.01)}</Typography>
                        }
                    }
                }
            }
        },
        {
            field: 'totalVat',
            headerName: t("preview.tables.taxes.tax-amount"),
            width: "13%",
            cellStyle: 'right',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'right'} fontWeight={600} sx={{ paddingTop: "2ch" }}>{formatCurrency(data.totalVat, props.invoice.currency, 0.01)}</Typography>
                        } else if (data.type === "TOTAL_WITHHOLDING_TAX" || data.type === "TOTAL_NET") {
                            return <Typography align={'right'} fontWeight={600}></Typography>
                        } else {
                            return <Typography align={'right'} fontWeight={400}>{formatCurrency(data.totalVat, props.invoice.currency, 0.01)}</Typography>
                        }
                    }
                }
            }
        },
        {
            field: 'totalGrossPrice',
            headerName: t("preview.tables.taxes.total-amount"),
            width: "13%",
            cellStyle: 'right',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'right'} fontWeight={600} color={'accent.main'}
                                               sx={{ paddingTop: "2ch" }}>{formatCurrency(data.totalGrossPrice, props.invoice.currency, 0.01)}</Typography>
                        } else if (data.type === "TOTAL_WITHHOLDING_TAX") {
                            if (!data?.vatRate.includes("0%")){
                                return <Typography align={'right'} fontWeight={600} color={'accent.main'}>{formatCurrency(data.totalGrossPrice, props.invoice.currency, 0.01)}</Typography>
                            } else return "";
                        } else if (data.type === "TOTAL_NET") {
                            return <Typography align={'right'} fontWeight={600} color={'accent.main'}>{formatCurrency(data.totalGrossPrice, props.invoice.currency, 0.01)}</Typography>
                        } else {
                            return <Typography align={'right'} fontWeight={400}>{formatCurrency(data.totalGrossPrice, props.invoice.currency, 0.01)}</Typography>
                        }
                    }
                }
            }
        }
    ];

    const footer = {
        vatRate: t("preview.tables.taxes.total-debit-label"),
        totalNetPrice: props.invoice.totalNetPrice,
        totalVat: props.invoice.totalVat,
        totalGrossPrice: props.invoice.totalGrossPrice,
        type: "TOTAL"
    }
    const footer2 = {
        vatRate: t('preview.tables.taxes.total-withholding-tax-label', {
            withholdingTax: props.invoice.items.find((it: any) => it.withholdingTax != null)?.withholdingTax || '0'
        }),
        totalNetPrice: '',
        totalVat: '',
        totalGrossPrice: -props.invoice.totalWithholdingTax || '',
        type: "TOTAL_WITHHOLDING_TAX"
    }
    const footer3 = {
        vatRate: t('preview.tables.taxes.total-net-label'),
        totalNetPrice: '',
        totalVat: '',
        totalGrossPrice: (props.invoice.totalGrossPrice - props.invoice.totalWithholdingTax) || '',
        type: "TOTAL_NET"
    }

    return (
            <InvoiceSimpleTable columnDefs={columnDefs} data={[...props.invoice.vatRate, footer, footer2, footer3]}/>
    )
}
export default PayableInvoiceTaxes;